import { useEffect, useState } from "react";
import { Hash, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function FavoriteHashtags({ businessId, canEdit = true }) {
  const [tags, setTags] = useState([]);
  const [draft, setDraft] = useState("");
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    setTags([]); setDirty(false);
    if (!businessId) return;
    api.get(`/businesses/${businessId}/hashtags`).then((r) => setTags(r.data.hashtags || [])).catch(() => {});
  }, [businessId]);

  const add = () => {
    const items = draft.split(/[\s,]+/).map((t) => t.replace(/^#+/, "").replace(/[^\p{L}\p{N}_]/gu, "")).filter(Boolean).map((t) => `#${t}`);
    const next = [...tags];
    items.forEach((t) => { if (!next.some((x) => x.toLowerCase() === t.toLowerCase())) next.push(t); });
    if (next.length > 15) { toast.error("Maksimal 15 hashtag favorit"); return; }
    setTags(next); setDraft(""); setDirty(true);
  };

  const save = async () => {
    setSaving(true);
    try {
      const r = await api.put(`/businesses/${businessId}/hashtags`, { hashtags: tags });
      setTags(r.data.hashtags); setDirty(false);
      toast.success("Hashtag favorit disimpan");
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  if (!businessId) return null;
  return (
    <div className="bg-[#FFFFFF] border border-[#E2E8F0] rounded-xl p-3 space-y-2" data-testid="favorite-hashtags">
      <div className="flex items-center gap-1.5">
        <Hash size={13} className="text-[#2563EB]" />
        <p className="text-xs font-semibold text-slate-700 flex-1">Hashtag Favorit Bisnis</p>
        <span className="text-[10px] text-slate-500">{tags.length}/15 · selalu ditambahkan ke Caption Reels AI</span>
      </div>
      <div className="flex flex-wrap gap-1.5" data-testid="favorite-hashtags-list">
        {tags.length === 0 && <span className="text-[11px] text-slate-600">Belum ada hashtag favorit</span>}
        {tags.map((t) => (
          <span key={t} className="inline-flex items-center gap-1 text-[11px] bg-[#EFF6FF] text-[#1D4ED8] px-2 py-0.5 rounded-full" data-testid={`favorite-hashtag-${t.slice(1)}`}>
            {t}
            {canEdit && <button type="button" onClick={() => { setTags(tags.filter((x) => x !== t)); setDirty(true); }} data-testid={`favorite-hashtag-remove-${t.slice(1)}`} className="hover:text-[#E11D48]"><X size={10} /></button>}
          </span>
        ))}
      </div>
      {canEdit && (
        <div className="flex gap-2">
          <Input value={draft} onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }} placeholder="#KopiNusantara #NgopiSantai" data-testid="favorite-hashtag-input" className="bg-[#FFFFFF] border-[#E2E8F0] h-8 text-xs" />
          <Button type="button" size="sm" variant="outline" onClick={add} disabled={!draft.trim()} data-testid="favorite-hashtag-add" className="h-8 rounded-lg text-xs">Tambah</Button>
          <Button type="button" size="sm" onClick={save} disabled={!dirty || saving} data-testid="favorite-hashtag-save" className="h-8 rounded-lg text-xs bg-[#2563EB] hover:bg-[#1D4ED8]">
            {saving && <Loader2 size={12} className="animate-spin mr-1" />} Simpan
          </Button>
        </div>
      )}
    </div>
  );
}
